import React, { PropsWithChildren } from 'react';
import { useLocation, Navigate } from 'react-router';
import { useAuthContext } from 'domain/auth/hooks/useAuthContext';

function RequireAuth({ children }: PropsWithChildren<unknown>) {
  const { accessToken, refreshToken } = useAuthContext();
  const location = useLocation();

  return !accessToken || !refreshToken ? <Navigate to="/signIn" state={{ from: location }} replace /> : <>{children}</>;
}

export default RequireAuth;
